var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9633 37.544H26.0273V17.64L18.7313 20.584C18.1339 20.2853 17.5793 19.8373 17.0673 19.24C16.5979 18.6427 16.3633 17.8533 16.3633 16.872C16.3633 14.9947 17.4939 13.6507 19.7552 12.84L27.8833 9.64H29.6753C30.9979 9.64 32.0433 10.024 32.8113 10.792C33.5793 11.56 33.9633 12.6267 33.9633 13.992V37.544ZM26.0273 32.104H33.9633V49C33.6219 49.128 33.1313 49.2347 32.4913 49.32C31.8513 49.448 31.1473 49.512 30.3793 49.512C28.8859 49.512 27.7766 49.2347 27.0513 48.68C26.3686 48.1253 26.0273 47.1653 26.0273 45.8V32.104Z",
    fill: "#DF1995"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF1);
export default __webpack_public_path__ + "static/media/f1.8fcc7c73da5e9979b0d72e8f041d6baa.svg";
export { ForwardRef as ReactComponent };